
interface ErrorResponse {
    code: number;
    message: string;
}

export interface encryptedData {
    rtag: string;
}

export interface EncryptedDataState {
    encryptedData: encryptedData;
    loadingEncryptedData: boolean;
    encryptedDataError: ErrorResponse | null;
}

export enum EncryptedDataActionTypes {
    FETCH_ENCRIPTION_DATA = "FETCH_ENCRIPTION_DATA",
    FETCH_ENCRIPTION_DATA_SUCCESS = "FETCH_ENCRIPTION_DATA_SUCCESS",
    FETCH_ENCRIPTION_DATA_ERROR = "FETCH_ENCRIPTION_DATA_ERROR",
}

export type EncryptedDataCreateAction =
    | { type: EncryptedDataActionTypes.FETCH_ENCRIPTION_DATA }
    | { type: EncryptedDataActionTypes.FETCH_ENCRIPTION_DATA_SUCCESS; payload: encryptedData }
    | { type: EncryptedDataActionTypes.FETCH_ENCRIPTION_DATA_ERROR; payload: ErrorResponse };